import { computed, onBeforeMount, ref } from 'vue'
import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import StafetAddDeltager from '../StafetAddDeltager/StafetAddDeltager.vue'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'

export default {
    name: 'StafetDeltagPaaHoldStepThree',
    components: {
        FormInputTextField,
        FormInputDropdown,
        FormCheckbox,
        StafetActions,
        StafetAddDeltager
    },
    props: _stafetCommonStepsProps,
    setup() {
        const addMoreParticipants = ref(false)
        const participants = ref({})

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_JOIN_A_TEAM
            )

            if (storedFields) {
                let adultParticipants = []
                let childParticipants = []

                if (getFieldValue(storedFields, 'deltagere')) {
                    adultParticipants = getFieldValue(storedFields, 'deltagere')
                }

                if (getFieldValue(storedFields, 'childDeltagere')) {
                    childParticipants = getFieldValue(
                        storedFields,
                        'childDeltagere'
                    )
                }

                participants.value.adults = adultParticipants
                participants.value.children = childParticipants

                const totalLength =
                    adultParticipants.length + childParticipants.length
                addMoreParticipants.value = totalLength > 0
            }
        })

        const toggleAddMoreParticipants = (value) => {
            addMoreParticipants.value = value
        }

        const stepModel = computed(() => {
            let result = []

            if (addMoreParticipants.value) {
                result.push({
                    name: 'deltagere',
                    value: participants.value.adults,
                    isValid: participants.value.isValid,
                    validator: () => participants.value.isValid
                })
                result.push({
                    name: 'childDeltagere',
                    value: participants.value.children,
                    isValid: participants.value.isValid,
                    validator: () => participants.value.isValid
                })
            }

            return result
        })

        const updateAddParticipants = (data) => {
            participants.value = data
        }

        return {
            addMoreParticipants,
            participants,
            toggleAddMoreParticipants,
            updateAddParticipants,
            stepModel
        }
    }
}
